import React, { useMemo } from 'react';

const SnowEffect = ({ intensity = 'medium', color = '#ffffff' }) => {
  const intensityMap = {
    subtle: 30,
    medium: 60,
    heavy: 100
  };

  const count = intensityMap[intensity] || 60;

  const snowflakes = useMemo(() => {
    const flakes = [];
    for (let i = 0; i < count; i++) {
      flakes.push({
        id: i,
        left: Math.random() * 100,
        size: 3 + Math.random() * 8,
        animationDuration: 5 + Math.random() * 10,
        animationDelay: Math.random() * 10,
        opacity: 0.4 + Math.random() * 0.6,
        drift: -20 + Math.random() * 40
      });
    }
    return flakes;
  }, [count]);

  return (
    <div className="snow-container">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            opacity: flake.opacity,
            backgroundColor: color,
            '--drift': `${flake.drift}px`
          }}
        />
      ))}
      <style>{`
        .snow-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 9997;
          overflow: hidden;
        }
        .snowflake {
          position: absolute;
          top: -20px;
          border-radius: 50%;
          box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
          animation: snowfall linear infinite;
        }
        @keyframes snowfall {
          0% {
            transform: translateY(-20px) translateX(0) rotate(0deg);
            opacity: 1;
          }
          50% {
            transform: translateY(50vh) translateX(var(--drift)) rotate(180deg);
          }
          100% {
            transform: translateY(100vh) translateX(calc(var(--drift) * -1)) rotate(360deg);
            opacity: 0.3;
          }
        }
      `}</style>
    </div>
  );
};

export default SnowEffect;
